import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import FAQ from '../components/sections/FAQ';
import Contact from '../components/sections/Contact';
import ContactModal from '../components/ContactModal';

export default function FAQPage() {
  const [showContactModal, setShowContactModal] = useState(false);

  const openContactModal = () => setShowContactModal(true);
  const closeContactModal = () => setShowContactModal(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>Preguntas Frecuentes | Inerva Psicología</title>
        <meta
          name="description"
          content="Resolvemos tus dudas sobre la terapia online, las sesiones, la confidencialidad y cómo trabajamos en Inerva Psicología."
        />
        <link rel="canonical" href="https://www.inervapsicologia.es/faq" />
      </Helmet>

      <Header />

      <main>
        <div className="reveal pt-32 lg:pt-40"><FAQ /></div>
        <Contact onContactClick={openContactModal} />
      </main>

      <Footer />

      <ContactModal show={showContactModal} handleClose={closeContactModal} />
    </>
  );
}
